'use client';
import React, { createContext } from 'react';

export const FieldsetContext = createContext({ path: '' });
FieldsetContext.displayName = 'FieldsetContext';

interface BaseFieldProps {
  bind?: string[] | string;
  name: string | string[];
}

function extendName(path: string | undefined, name: string): string;
function extendName(path: string | undefined, name: undefined): undefined;
function extendName(path: string | undefined, name: string[]): string[];

function extendName(
  path: string = '',
  name: string | undefined | string[],
): string | string[] | undefined {
  if (name === undefined) return undefined;
  if (name === '') return path;
  if (Array.isArray(name)) {
    return name.map((n) => extendName(path, n));
  }
  return `${path}${path.length > 0 ? '.' : ''}${name}`;
}
export const useFieldSetConsumer = <T extends BaseFieldProps>(props: T) => {
  const { path } = React.useContext(FieldsetContext);
  const bind = React.useMemo(() => {
    const propsBind = props.bind
      ? Array.isArray(props.bind) ? props.bind : [props.bind]
      : undefined;
    const _bind = path ? (propsBind || []).concat(path) : propsBind;
    // 只有当路径中包含超过1个索引时才需要去掉最后一个索引
    return _bind?.map((b) => {
      const indexCount = (b.match(/\[\d+\]/g) || []).length;
      return indexCount > 1 ? b.replace(/\[\d+\]$/, '') : b;
    });
  }, [path, props.bind]);
  const name = React.useMemo(() => {
    return extendName(path, props.name as any);
  }, [path, props.name]);

  return {
    ...props,
    name,
    bind,
  };
};

export default FieldsetContext;
